import { DeptLeads } from "src/app/models/dept-leads";

export interface DepartmentLeadsState{
    departmentLeads: DeptLeads[];
}

export const initialDepartmentLeadsState: DepartmentLeadsState = {
    departmentLeads: []
}